import { type ReactElement, useEffect, useRef } from "react";
import { useIsAuthenticated, useSignOut } from "react-auth-kit";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
  children: ReactElement;
  loginPath: string;
}

export default function RequireAuth({ children, loginPath }: Props) {
  const isAuthenticated = useIsAuthenticated();
  const signOut = useSignOut();
  const location = useLocation();
  const authenticated = isAuthenticated();
  const didSignOut = useRef(false); // Auth Kit recreates signOut on every render.

  useEffect(() => {
    if (authenticated) {
      didSignOut.current = false;
    } else if (!didSignOut.current) {
      didSignOut.current = true;
      signOut();
    }
  }, [authenticated, signOut]);

  return authenticated ? (
    children
  ) : (
    <Navigate to={loginPath} state={{ from: location }} replace />
  );
}
